export const GET_BOM_FINISHED_GOODS = 'GET_BOM_FINISHED_GOODS';
export const GET_BOM_FINISHED_GOODS_SUCCESS = 'GET_BOM_FINISHED_GOODS_SUCCESS';
export const GET_BOM_FINISHED_GOODS_FAILED = 'GET_BOM_FINISHED_GOODS_FAILED';

export const ADD_BOM_FINISHED_GOODS = 'ADD_BOM_FINISHED_GOODS';
export const ADD_BOM_FINISHED_GOODS_SUCCESS = 'ADD_BOM_FINISHED_GOODS_SUCCESS';
export const ADD_BOM_FINISHED_GOODS_FAILED = 'ADD_BOM_FINISHED_GOODS_FAILED';

export const UPDATE_BOM_FINISHED_GOODS = 'UPDATE_BOM_FINISHED_GOODS';
export const UPDATE_BOM_FINISHED_GOODS_SUCCESS = 'UPDATE_BOM_FINISHED_GOODS_SUCCESS';
export const UPDATE_BOM_FINISHED_GOODS_FAILED = 'UPDATE_BOM_FINISHED_GOODS_FAILED';

export const DELETE_BOM_FINISHED_GOODS = 'DELETE_BOM_FINISHED_GOODS';
export const DELETE_BOM_FINISHED_GOODS_SUCCESS = 'DELETE_BOM_FINISHED_GOODS_SUCCESS';
export const DELETE_BOM_FINISHED_GOODS_FAILED = 'DELETE_BOM_FINISHED_GOODS_FAILED'; 